import { AxiosPost, AxiosGet } from "../../services/AxiosWrapper";
import { MANAGEMENT_SERVICE_URL } from "../../constants/ServiceUrls";

export const upsertPasswordPolicies = (upsertPasswordPoliciesParameters) => {
  return AxiosPost(
    `${MANAGEMENT_SERVICE_URL}api/PasswordAdministration/UpsertPasswordPolicies`,
    upsertPasswordPoliciesParameters
  );
};

export const getPasswordPolicies = () => {
  return AxiosGet(
    `${MANAGEMENT_SERVICE_URL}api/PasswordAdministration/GetPasswordPolicies`
  );
};
